import { Helmet } from 'react-helmet-async';
// @mui
import { Container, Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
// components
// sections
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom/dist';
import { AppContext } from 'src/components/Context/AppContext/app.context';
import { AuthContext } from 'src/components/Context/Auth/auth.context';
import ChangePassword from 'src/components/User/ChangePassword';
import { DashboardData } from 'src/components/services/httpServices';
import { AppWidgetSummary } from '../sections/@dashboard/app';
import MyCalendar from './Calendar/Calendar';

// ----------------------------------------------------------------------

export default function DashboardAppPage(props) {
  const theme = useTheme();
  const [CLIENTSCOUNT, setClientsCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const navigate = useNavigate();
  let { fetchEmployersAndClients, dataFetched, employers, customers } = useContext(AppContext);

  const fetchData = async (event) => {
    const savedData = await DashboardData();
    console.log('data:', savedData.data);
    setData(savedData.data);
    setLoading(false);
    if (!dataFetched || customers == null || employers.length == 0) {
      fetchEmployersAndClients();
    }
  };

  console.log('dataFetched:', dataFetched, customers, employers);
  let {
    authState: { userRole, deptId },
  } = useContext(AuthContext);

  useEffect(
    () => {
      // const fetch = async () => {
      //   const response = await GetTotalCustomersCount();
      //   if (response !== null) {
      //     setClientsCount(response.value);

      //     console.log('UsersLit', response);
      //   }
      // };
      // fetch();
      fetchData();
    },
    [dataFetched]
    // [pr],
    // [pr?.prQ1Collection]
  );

  return (
    <>
      <Helmet>
        <title> Dashboard | Immigration System </title>
      </Helmet>
      {props.firstPasswordChanged == 'false' ? (
        <Container maxWidth="xl">
          <ChangePassword />
        </Container>
      ) : (
        <Container maxWidth="xl">
          <Typography variant="h4" sx={{ mb: 5 }}>
            Hi, Welcome back
          </Typography>
          {/* <Draggable> */}
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={3}>
              <AppWidgetSummary
                loading={loading}
                onClick={() => navigate(`/app/MyTasks`)}
                title={`Total Task`}
                color="info"
                total={data?.myTasks}
                icon={'icons8:tasks'}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <AppWidgetSummary
                onClick={() => navigate(`/app/MyTasks`)}
                loading={loading}
                title="Pending Tasks"
                total={data?.myPendingTasks}
                icon={'material-symbols:pending-actions'}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <AppWidgetSummary
                loading={loading}
                onClick={() => navigate(`/app/MyTasks`)}
                title={`Completed Tasks Percentage %`}
                color="success"
                total={`${((data?.myTasks - data?.myPendingTasks) / data?.myTasks) * 100}`}
                icon={'clarity:tasks-line'}
                percentage={true}
              />
            </Grid>
            {/* 
            <Grid item xs={12} sm={6} md={3}>
              <AppWidgetSummary
                title="Footfalls Created by me."
                total={data?.myFootfalls}
                loading={loading}
                color="info"
                icon={'solar:walking-bold}
              />
            </Grid> */}
            <Grid item xs={12} sm={6} md={3}>
              <AppWidgetSummary
                title="My Opportunities as Clients"
                onClick={() => navigate(`/app/MyOpportunities`)}
                total={data?.myClients}
                loading={loading}
                color="secondary"
                icon={'solar:user-bold'}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <AppWidgetSummary
                title="My Opportunities as Employers"
                total={data?.myEmployers}
                onClick={() => navigate(`/app/MyOpportunities`)}
                loading={loading}
                color="secondary"
                // icon={'ant-design:dollar-circle-filled'}
                icon={'raphael:users'}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <AppWidgetSummary
                title="Today's Expiry"
                total={data?.todaysExpiry}
                onClick={() => navigate(`/app/NearExpiryClientsPage/${1}`)}
                loading={loading}
                color="error"
                // icon={'ant-design:dollar-circle-filled'}
                icon={'pajamas:expire'}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <AppWidgetSummary
                title="Near Expiry in a Week"
                total={data?.expiryInWeek}
                onClick={() => navigate(`/app/NearExpiryClientsPage/${7}`)}
                loading={loading}
                color="error"
                // icon={'ant-design:dollar-circle-filled'}
                icon={'pajamas:expire'}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <AppWidgetSummary
                title="Near Expiry in a Month"
                total={data?.expiryInMonth}
                onClick={() => navigate(`/app/NearExpiryClientsPage/${30}`)}
                loading={loading}
                color="error"
                // icon={'ant-design:dollar-circle-filled'}
                icon={'pajamas:expire'}
              />
            </Grid>
            {deptId == '6' || userRole === 'Master' ? (
              <>
                <Grid item xs={12} sm={6} md={3}>
                  <AppWidgetSummary
                    title="Total Interviews"
                    total={data?.totalInterviews}
                    onClick={() => navigate(`/app/recruitment`)}
                    loading={loading}
                    color="warning"
                    // icon={'ant-design:dollar-circle-filled'}
                    icon={'fluent-mdl2:recruitment-management'}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <AppWidgetSummary
                    title="Total Interviews You manage"
                    total={data?.totalInterviewsYouManage}
                    onClick={() => navigate(`/app/recruitment`)}
                    loading={loading}
                    color="warning"
                    // icon={'ant-design:dollar-circle-filled'}
                    icon={'fluent-mdl2:recruitment-management'}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <AppWidgetSummary
                    title="Total Interviews You have to take"
                    total={data?.totalInterviewsYouHavetoTake}
                    onClick={() => navigate(`/app/recruitment`)}
                    loading={loading}
                    color="warning"
                    // icon={'ant-design:dollar-circle-filled'}
                    icon={'fluent-mdl2:recruitment-management'}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <AppWidgetSummary
                    title="Today's Interviews You have to take"
                    total={data?.totalTodaysInterview}
                    onClick={() => navigate(`/app/recruitment`)}
                    loading={loading}
                    color="warning"
                    // icon={'ant-design:dollar-circle-filled'}
                    icon={'fluent-mdl2:recruitment-management'}
                  />
                </Grid>
              </>
            ) : null}
            <Grid item xs={12} sm={12} md={12}>
              <MyCalendar />
            </Grid>
            {/* 
            <Grid item xs={12} md={6} lg={8}>
              <AppWebsiteVisits
                title="Total Footfall by month"
                // subheader="(+43%) than last year"
                chartLabels={[
                  '01/01/2023',
                  '02/01/2023',
                  '03/01/2023',
                  '04/01/2023',
                  '05/01/2023',
                  '06/01/2023',
                  '07/01/2023',
                  '08/01/2023',
                  '09/01/2023',
                  '10/01/2023',
                  '11/01/2023',
                  '12/01/2023',
                ]}
                chartData={[
                  {
                    name: 'Toronto',
                    type: 'column',
                    fill: 'solid',
                    data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30, 30],
                  },
                  {
                    name: 'Vancouver',
                    type: 'area',
                    fill: 'gradient',
                    data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43, 20],
                  },
                  {
                    name: 'Calagry',
                    type: 'line',
                    fill: 'solid',
                    data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39, 30],
                  },
                  {
                    name: 'Edmonton',
                    type: 'line',
                    fill: 'solid',
                    data: [35, 26, 39, 40, 45, 35, 64, 52, 59, 36, 39, 40],
                  },
                ]}
              />
            </Grid> */}
            {/* <Grid item xs={12} md={6} lg={4}>
              <AppCurrentVisits
                title="Customers by Branches"
                chartData={[
                  { label: 'Toronto', value: 1000 },
                  { label: 'Calagry', value: 2000 },
                  { label: 'Vancouver', value: 500 },
                  { label: 'Edmonton', value: 500 },
                ]}
                chartColors={[
                  theme.palette.primary.main,
                  theme.palette.info.main,
                  theme.palette.warning.main,
                  theme.palette.error.main,
                ]}
              />
            </Grid> */}
            {/* <Grid item xs={12} md={6} lg={4}>
              <AppCurrentVisits
                title="Total Footfall by Branches"
                chartData={[
                  { label: 'Toronto', value: 10 },
                  { label: 'Calagry', value: data?.totalFootfalls },
                  { label: 'Vancouver', value: 20 },
                  { label: 'Edmonton', value: 30 },
                ]}
                chartColors={[
                  theme.palette.primary.main,
                  theme.palette.info.main,
                  theme.palette.warning.main,
                  theme.palette.error.main,
                ]}
              />
            </Grid> */}
            {/* <Grid item xs={12} md={6} lg={8}>
              <AppConversionRates
                title="Revenue by Immigration type"
                // subheader="(+43%) than last year"
                chartData={[
                  { label: 'Canada Express Entry', value: 400 },
                  { label: 'Work Permit', value: 430 },
                  { label: 'LMIA', value: 448 },
                  { label: 'Permanent Residence', value: 470 },
                  { label: 'Spousal Sponsership', value: 540 },
                  { label: 'Visa Applications', value: 580 },
                  { label: 'Provincial Nominee Program', value: 690 },
                  { label: 'Super Visa', value: 1100 },
                  // { label: 'United States', value: 1200 },
                  // { label: 'United Kingdom', value: 1380 },
                ]}
              />
            </Grid> */}
            {/* <Grid item xs={12} md={6} lg={4}>
              <AppCurrentSubject
                title="Employment Type"
                chartLabels={['Toronto', 'Calagry', 'Vancouver', 'Edmonton', 'Islamabad', 'Delhi']}
                chartData={[
                  { name: 'Temporary Forigen Worker', data: [80, 50, 30, 40, 100, 20] },
                  { name: 'International Workers', data: [20, 30, 40, 80, 20, 80] },
                  { name: 'Others', data: [44, 76, 78, 13, 43, 10] },
                ]}
                chartColors={[...Array(6)].map(() => theme.palette.text.secondary)}
              />
            </Grid> */}
            {/* <Grid item xs={12} md={6} lg={8}>
              <AppNewsUpdate
                title="News Update"
                list={[...Array(5)].map((_, index) => ({
                  id: faker.datatype.uuid(),
                  title: faker.name.jobTitle(),
                  description: faker.name.jobTitle(),
                  image: `/assets/images/covers/cover_${index + 1}.jpg`,
                  postedAt: faker.date.recent(),
                }))}
              />
            </Grid> */}
            {/* <Grid item xs={12} md={6} lg={4}>
              <AppOrderTimeline
              
                title="Visa Expiry Timelines"
                list={[...Array(5)].map((_, index) => ({
                  id: faker.datatype.uuid(),
                  title: [
                    '1983, orders, $4220',
                    '12 Invoices have been paid',
                    'Order #37745 from September',
                    'New order placed #XF-2356',
                    'New order placed #XF-2346',
                  ][index],
                  type: `order${index + 1}`,
                  time: faker.date.past(),
                }))}
              />
            </Grid> */}
            {/* <Grid item xs={12} md={6} lg={4}>
              <AppTrafficBySite
                title="Traffic by Site"
                list={[
                  {
                    name: 'FaceBook',
                    value: 323234,
                    icon: <Iconify icon={'eva:facebook-fill'} color="#1877F2" width={32} />,
                  },
                  {
                    name: 'Google',
                    value: 341212,
                    icon: <Iconify icon={'eva:google-fill'} color="#DF3E30" width={32} />,
                  },
                  {
                    name: 'Linkedin',
                    value: 411213,
                    icon: <Iconify icon={'eva:linkedin-fill'} color="#006097" width={32} />,
                  },
                  {
                    name: 'Twitter',
                    value: 443232,
                    icon: <Iconify icon={'eva:twitter-fill'} color="#1C9CEA" width={32} />,
                  },
                ]}
              />
            </Grid> */}
            {/* <Grid item xs={12} md={6} lg={8}>
              <AppTasks
                title="Tasks"
                list={[
                  { id: '1', label: 'Create FireStone Logo' },
                  { id: '2', label: 'Add SCSS and JS files if required' },
                  { id: '3', label: 'Stakeholder Meeting' },
                  { id: '4', label: 'Scoping & Estimations' },
                  { id: '5', label: 'Sprint Showcase' },
                ]}
              />
            </Grid> */}
          </Grid>
          {/* </Draggable> */}
        </Container>
      )}
    </>
  );
}
